import React, {useCallback, useLayoutEffect, useState} from 'react';
import ReactDOM from "react-dom";
import {Dropdown} from "presentation/common";
import {IoMdMore} from 'react-icons/io';

export const HeaderActions = ({onDownloadDocuments}) => {
  const [show, setShow] = useState(false);

  const onSelectItem = useCallback(
    item => {
      onDownloadDocuments?.();
    },
    [],
  );

  useLayoutEffect(() => {
    if(document.getElementById('header-actions-container')) {
      setShow(true);
    }
  }, [])

  if(!show) return <span/>;

  return ReactDOM.createPortal(
    <Dropdown items={[{id: 'download', label: 'Descargar'}]} onSelectItem={onSelectItem}>
      <IoMdMore size={18}/>
    </Dropdown>
    , document.getElementById('header-actions-container'));
};
